export default __webpack_public_path__ + "5e7f27cc1cb9699de972e59d3b24693c.svg";